import { render, staticRenderFns } from "./addBookkeeping.vue?vue&type=template&id=26d51ae1&scoped=true&"
import script from "./addBookkeeping.vue?vue&type=script&lang=js&"
export * from "./addBookkeeping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d51ae1",
  null
  
)

export default component.exports